import { render, staticRenderFns } from "./twitter-embed.vue?vue&type=template&id=7eb1dd69&scoped=true&"
import script from "./twitter-embed.vue?vue&type=script&lang=js&"
export * from "./twitter-embed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eb1dd69",
  null
  
)

export default component.exports